import React from "react";

import { useTranslation } from "react-i18next";

import { BetSlipStatusAbrv } from "@utils";

export default function BetItemPaymentDetail(props: {
	betStatusAbrv: string;
	betSlipStatusAbrv: string;
	maxGain: string;
	payout: string;
}) {
	const { t } = useTranslation("mybets");

	if (
		props.betStatusAbrv == BetSlipStatusAbrv.WON &&
		(props.betSlipStatusAbrv == BetSlipStatusAbrv.PAID_OUT ||
			props.betSlipStatusAbrv == BetSlipStatusAbrv.CASHOUT)
	) {
		return (
			<>
				<div className="widget--bets__label">
					{t<string>("ITEM.INFO_PAYOUT_LABEL")}:
				</div>
				<div className="widget--bets__amount">{props.payout}</div>
			</>
		);
	}

	return (
		<>
			<div className="widget--bets__label">
				{t<string>("ITEM.INFO_MAX_GAIN_LABEL")}:
			</div>
			<div className="widget--bets__amount">{props.maxGain}</div>
		</>
	);
}
